import * as Yup from 'yup';
import i18n from 'i18n';

const schema = Yup.object().shape({
  email: Yup.string()
    .required(() => i18n.t('common:validation.fieldRequired'))
    .email(() => i18n.t('common:validation.emailInvalid')),
});

export default schema;
